import { addCustomAttribute } from "@MasterBluePrint/Handlers/Common/NoibuLibrary";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { BillToModel, ShipToModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = Handler<
    {
        billingAddress: BillToModel | undefined;
        shippingAddress: ShipToModel | undefined;
    }
>;

export const AddNoibuAttributesInCheckoutShipping: HandlerType = props => {
    const billingAddress = props.parameter.billingAddress;
    if (billingAddress) {
        addCustomAttribute("billTo-email", billingAddress.email);
        addCustomAttribute("billTo-address1", billingAddress.address1);
        addCustomAttribute("billTo-country", billingAddress.country?.name ?? "");
        addCustomAttribute("billTo-state", billingAddress.state?.name ?? "");
        addCustomAttribute("billTo-postalCode", billingAddress.postalCode);
    }

    const shippingAddress = props.parameter.shippingAddress;
    if (shippingAddress) {
        addCustomAttribute("shipTo-email", shippingAddress.email);
        addCustomAttribute("shipTo-address1", shippingAddress.address1);
        addCustomAttribute("shipTo-country", shippingAddress.country?.name ?? "");
        addCustomAttribute("shipTo-state", shippingAddress.state?.name ?? "");
        addCustomAttribute("shipTo-postalCode", shippingAddress.postalCode);
    }
};

export const chain = [AddNoibuAttributesInCheckoutShipping];

const addNoibuAttributesInCheckoutShipping = createHandlerChainRunner(chain, "AddNoibuAttributesInCheckoutShipping");
export default addNoibuAttributesInCheckoutShipping;
